import { render, staticRenderFns } from "./KiaManual.vue?vue&type=template&id=583c9b8f&"
import script from "./KiaManual.vue?vue&type=script&lang=js&"
export * from "./KiaManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports